module.exports = __webpack_public_path__ + "img/mt.74a57dcb.svg";